'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var name = 'CMS-Blurb06';
var defaultProps = {
	align: 'center',
	horizontal: 'center',
	isForegroundClickable: true,
	styleClasses: {},
	vertical: 'center'
};

var renderButtons = function renderButtons(props) {
	var numbers = Array.from(Array(props.buttonQuantity).keys()).map(function (index) {
		return index + 1;
	});

	return numbers.filter(function (number) {
		return props['button' + number + 'Text'];
	}).map(function (number) {
		return (0, _magicVirtualElement2.default)(
			'a',
			{ key: number, href: props['button' + number + 'Url'], 'class': [name + '-button', props.styleClasses['Button_' + number]], 'data-style-attr': 'Button_' + number },
			props['button' + number + 'Text']
		);
	});
};

var render = function render(_ref) {
	var props = _ref.props;

	var classes = [name, props.class, props.styleClasses.Blurb, (props.children.length === 0 || props.isForegroundClickable) && name + '--clickableForeground'];
	var contentStyles = {
		'margin-left': props.marginLeft,
		'margin-right': props.marginRight,
		'margin-top': props.marginTop,
		'margin-bottom': props.marginBottom
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': classes, 'data-style-attr': 'Blurb' },
		props.children.length > 0 && (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': name + '-background' },
			props.children
		),
		props.showContentOnHover && (0, _magicVirtualElement2.default)('div', { 'class': name + '-overlay' }),
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': [name + '-foreground', name + '--horizontal' + props.horizontal, name + '--vertical' + props.vertical, props.showContentOnHover && name + '-foreground-animation'] },
			(0, _magicVirtualElement2.default)(
				'div',
				{ 'class': [name + '-content', props.styleClasses.Content, name + '--align' + props.align], style: contentStyles, 'data-style-attr': 'Content' },
				props.heading1 && (0, _magicVirtualElement2.default)(
					'h1',
					{ 'class': props.styleClasses.Heading_1, 'data-style-attr': 'Heading_1' },
					props.heading1
				),
				props.heading2 && (0, _magicVirtualElement2.default)(
					'h2',
					{ 'class': props.styleClasses.Heading_2, 'data-style-attr': 'Heading_2' },
					props.heading2
				),
				props.showLine && (0, _magicVirtualElement2.default)('div', { 'class': [name + '-line', props.styleClasses.Line], 'data-style-attr': 'Line' }),
				props.heading3 && (0, _magicVirtualElement2.default)(
					'h3',
					{ 'class': props.styleClasses.Heading_3, 'data-style-attr': 'Heading_3' },
					props.heading3
				),
				(0, _magicVirtualElement2.default)(
					'div',
					{ 'class': name + '-buttons' },
					renderButtons(props)
				)
			)
		)
	), props);
};

exports.default = { defaultProps: defaultProps, render: render };